import { FlexColumn, Loading, MaterialIcon, useLoading } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useEffect } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { LIVE_PAGE } from '../../../constants/app';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { getNotification } from '../../../services/notificationService';
import { apiParamsState } from '../../../storage/app';
import { notificationSelectedState } from '../../../storage/notifications';
import { NotificationLinkableSection } from '../../../types/notification';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import NotificationEvidencesLibrary from '../../notifications/NotificationEvidencesLibrary';
import { NotificationInfo } from '../../notifications/NotificationInfo';
import { StyledTooltip } from '../../ui/StyledTooltip';

function NotificationEvidencesPage() {
  const { id: workspaceId, notificationId } = useParams();
  const { loading, startLoading, stopLoading } = useLoading(true);
  const { showFailFeedback } = useFeedback();
  const { theme, css } = useStyles();
  const [notification, setNotification] = useRecoilState(notificationSelectedState);
  const apiParams = useRecoilValue(apiParamsState);
  const navigate = useNavigate();
  const section = notification?.actions?.viewDetails.section;

  useEffect(() => {
    const loadNotification = async () => {
      if (!apiParams?.clientId || !notificationId || !apiParams?.subClientId) return;
      startLoading();
      const { notification: notificationResponse, error } = await getNotification(
        apiParams.clientId,
        apiParams.subClientId,
        notificationId,
      );
      if (!error && notificationResponse) {
        setNotification(notificationResponse);
      } else {
        showFailFeedback(error ?? 'Ocurrió un error al cargar la notificación.');
        setNotification(undefined);
      }
      stopLoading();
    };

    void loadNotification();
  }, [apiParams?.clientId, notificationId, apiParams?.subClientId]);

  if (!notificationId) {
    return null;
  }

  const onClose = () => {
    void navigate(generatePath(LIVE_PAGE.route, { id: workspaceId }));
  };

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
          classNames={css({ height: '100%', overflow: 'hidden' })}
        >
          <FlexColumn classNames={css({ flex: 1, overflow: 'hidden' })}>
            {loading && <Loading />}
            {!loading && (
              <>
                <FlexColumn classNames={css({ minHeight: '176px' })}>
                  <NotificationInfo
                    notification={notification}
                    endActions={
                      <StyledTooltip
                        content="Cerrar"
                        showArrow={false}
                      >
                        <Button
                          shape="circle"
                          kind="tertiary"
                          size="compact"
                          onClick={onClose}
                        >
                          <MaterialIcon
                            name="close"
                            size="mini"
                          />
                        </Button>
                      </StyledTooltip>
                    }
                  />
                </FlexColumn>
                {section === NotificationLinkableSection.alarmEvidences && notification?.origin && (
                  <NotificationEvidencesLibrary
                    evidences={notification?.actions?.viewDetails.params.evidences || []}
                    notificationId={notificationId}
                    origin={notification.origin}
                  />
                )}
              </>
            )}
          </FlexColumn>
        </FloatingCardContent>
      }
      contentSize={550}
    />
  );
}

export default NotificationEvidencesPage;
